import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Badge from '@mui/material/Badge';
import {
  BASE_URL,
  dateFormatter,
  dropdownFetch,
  getCityByState,
  getCurrentDateTime,
  getDateDifference,
  getKeyPathValue,
  getStateNameByStateCode,
  getStatesByCountry,
  getISTDate,
  request,
  toast
} from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import {
  BANK_CASH,
  BLOOD_GROUPS,
  CARD_TYPE,
  GENDER_DROPDOWN,
  NATIONALITY,
  RECEIPT_MODE,
  REFERRAL_TYPE,
  REG_LOCATION,
  RELIGIONS,
  TITLES,
  YES_NO
} from '../../../../../constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { useRef } from 'react';
import axios from 'axios';

const TABLE_COLUMNS = [
  { header: 'UHID No.', accessor: 'uhid' },
  { header: 'OP No.', accessor: 'op_no' },
  { header: 'Date', accessor: (row) => `${getCurrentDateTime('date', row?.date)}` },
  {
    header: 'Patient name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.name_suffix} ${row?.first_name} ${row?.last_name ? row?.last_name : ''}`}
        </span>
      );
    }
  },
  { header: 'Guardian', accessor: 'guardian_name' },
  { header: 'Mobile No.', accessor: 'address.mobile' },
  {
    header: 'State Name',
    accessor: (row) => {
      const state = row?.address?.state;
      return typeof state === 'object' ? state?.state : state || 'N/A';
    }
  },
  { header: 'Aadhar No.', accessor: 'address.aadhar' },
  { header: 'Doctor Name', accessor: 'consultant.name' },
  { header: 'Recd Amount', accessor: 'recd' },
  { header: 'Sponsor Name', accessor: 'sponsor.name' },
  { header: 'Address', accessor: 'address.address' },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
];

const APPOINTMENT_TABLE_COLUMNS = [
  { header: 'App No.', accessor: 'app_no' },
  { header: 'App. Date', accessor: (row) => `${getCurrentDateTime('date', row?.createdAt)}` },
  {
    header: 'Patient name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient_name}`}
        </span>
      );
    }
  },
  { header: 'Mobile No.', accessor: 'mobile' },

  { header: 'Doctor Name', accessor: (row) => row?.doctor?.name },
  { header: 'Recd Amount', accessor: 'recd' },
  { header: 'Address', accessor: 'address' },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
];

const initialPatientDataObj = {
  data: [],
  loading: false
};

const initialAppointmentDataObj = {
  data: [],
  loading: false
};

export const PatientRegisteration = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [appointmentDataObj, setAppointmentDataObj] = useState(initialAppointmentDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [openAppointmentDialog, setOpenAppointmentDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState();
  const [input, setInput] = useState('');
  const [appointmentInput, setAppointmentInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const [appointmentOriginalData, setAppointmentOriginalData] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));

  const [newDate, setnewDate] = useState(false);

  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  const getCurrentDateTime = (type = '', date = null) => {
    // If no date is passed, use the current date
    let currentDate = date ? new Date(date) : new Date();
    const minutes = currentDate.getMinutes();
    const month = currentDate.getMonth() + 1; // Months are 0-based, hence +1
    const day = currentDate.getDate();

    if (type === 'date') {
      // Return date in DD-MM-YYYY format
      return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${currentDate.getFullYear()}`;
    } else if (type === 'time') {
      // Return time in HH:MM format
      return `${currentDate.getHours()}:${minutes < 10 ? '0' + minutes : minutes}`;
    }

    // Fallback: If no type or unknown type, return default formatted datetime
    return currentDate.toISOString(); // Use ISO format as a fallback or customize this.
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        first_name: Yup.string().required(' '),
        guardian_name: Yup.string().required(''),
        religion: Yup.string().required(' '),
        blood_group: Yup.string().required(' '),
        sponsor: Yup.string().required(' '),
        nationality: Yup.string().required(' '),
        gender: Yup.string().required(' '),
        age_year: Yup.string().required(''),
        vertical: Yup.string().required(' '),
        consultant: Yup.string().required(' '),
        reg_loc: Yup.string().required(' '),
        ref_by: Yup.string().required(' '),
        department: Yup.string().required(' '),
        opd_type: Yup.string().required(' '),
        address: Yup.object().shape({
          address: Yup.string().required(' '),
          country: Yup.string().required(' '),
          state: Yup.string().required(' '),
          city: Yup.string().required(' '),
          mobile: Yup.string()
            .required('Mobile number is required')
            .matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
        }),
        receipt_mode: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: getISTDate(), // ← Correct IST date only
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      name_suffix: 'Mr.',
      dob: getCurrentDateTime('date').split('-').reverse().join('-'),
      // age_year: 0,
      // age_month: 0,
      // age_day: 0,
      gender: 'Male',
      religion: 'NA',
      blood_group: 'NA',
      nationality: 'Indian',
      reg_loc: 'Hospital',
      consult: false,
      receipt_mode: 'CASH',
      payment_mode: 'CASH',
      address: {
        country: 'IN',
        state: 'Haryana',
        city: 'Panipat'
      },
      correspondance: {
        country: 'IN'
      },
      covid: {
        symptom: 'No',
        travel: 'No',
        history: 'No',
        report: 'No',
        suspected_health_care: 'No',
        screen_for_sari: 'No',
        antibody_testing: 'No'
      },
      reg: 0,
      cons: 0,
      disc: 0,
      total: 0,
      recd: 0,
      bal: 0,
      other_charge: 0
    },
    mode: 'all'
  });
  const { handleSubmit, watch, setValue, reset } = methods;
  const { getValues } = useForm();
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [discountMasterDropdown, setDiscountMasterDropdown] = useState([]);
  const [doctorUnitDropdown, setDoctorUnitDropdown] = useState([]);
  const [verticalDropdown, setVerticalDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [guardianDropdown, setGuardianDropdown] = useState([]);
  const [referralDropdown, setReferralDropdown] = useState([]);
  const [openReferralDialog, setOpenReferralDialog] = useState(false);
  const [newReferralType, setNewReferralType] = useState('');
  const [newReferralName, setNewReferralName] = useState('');
  const [referralSaving, setReferralSaving] = useState(false);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [opdTypeDropdown, setopdTypeDropdown] = useState([]);
  const [rankDropdown, setRankDropdown] = useState([]);
  const [fluTypeDropdown, setFluTypeDropdown] = useState([]);
  const [doctorFeeData, setDoctorFeeSetup] = useState([]);
  const [stateName, setStateName] = useState([]);
  const [cityName, setCityName] = useState([]);
  const [finalAmount, setfinalAmount] = useState();
  const [selectedOpdType, setSelectedOpdType] = useState(false);

  const fieldOneRef = useRef(null);
  const fieldTwoRef = useRef(null);
  const fieldThreeRef = useRef(null);
  const fieldFourRef = useRef(null);
  const fieldFiveRef = useRef(null);
  const fieldSixRef = useRef(null);
  const fieldSevenRef = useRef(null);
  const fieldEightRef = useRef(null);
  const [notificationCountPending, setNotificationCountPending] = useState(0);
  const [notificationCountConfirm, setNotificationCountConfirm] = useState(0);
  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef) {
      e.preventDefault();
      nextFieldRef.current.focus();
    }
  };

  const getDoctorFeeData = useCallback(async () => {
    const data = await dropdownFetch('doctor-fee-setup');
    setDoctorFeeSetup(data);
  }, []);

  const getDiscountmasterData = useCallback(async () => {
    const data = await dropdownFetch('discount');
    setDiscountMasterDropdown(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('sponsor', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, [selectedRecord]);

  const getDoctorUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-unit');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('consult_unit', defaultSponsor?._id);
    }
    setDoctorUnitDropdown(data);
  }, [selectedRecord]);

  const getVerticalDropdown = useCallback(async () => {
    const data = await dropdownFetch('vertical-master');
    if (!selectedRecord) {
      const [defaultVerticalMaster] = data.filter(({ status }) => status === 'default');
      setValue('vertical', defaultVerticalMaster?._id);
    }
    setVerticalDropdown(data);
  }, [selectedRecord]);
  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }

    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getGuardianDropdown = useCallback(async () => {
    const data = await dropdownFetch('relation-master');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('guardian_type', defaultState?._id);
    }
    setGuardianDropdown(data);
  }, [selectedRecord]);

  const getReferralDropdown = useCallback(async () => {
    const data = await dropdownFetch('referral');
    if (!selectedRecord) {
      const [defaultReferal] = data.filter(({ status }) => status === 'default');
      setValue('ref_by', defaultReferal?._id);
    }
    setReferralDropdown(data);
  }, [selectedRecord]);

  const handleAddReferral = async () => {
    if (!newReferralType || !newReferralName.trim()) {
      toast('Referral Type and Referral Name are required', { variant: 'error' });
      return;
    }
    setReferralSaving(true);
    const response = await request('/referral-create', {
      method: 'POST',
      body: { referral_type: newReferralType, referral_name: newReferralName.trim() }
    });
    setReferralSaving(false);
    if (response?.success) {
      setReferralDropdown((prev) => [...prev, response.referral]);
      setValue('ref_by', response.referral._id);
      toast('Referral added successfully', { variant: 'success' });
      setOpenReferralDialog(false);
      setNewReferralType('');
      setNewReferralName('');
    } else {
      toast('Failed to add referral', { variant: 'error' });
    }
  };

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);
  const getopdTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('opd-type');
    if (!selectedRecord) {
      const [defaultOpdType] = data.filter(({ status }) => status === 'default');
      setValue('opd_type', defaultOpdType?._id);
    }
    setopdTypeDropdown(data);
  }, [selectedRecord]);

  const getRankDropdown = useCallback(async () => {
    const data = await dropdownFetch('rank-master');
    if (!selectedRecord) {
      const [defaultRankMaster] = data.filter(({ status }) => status === 'default');
      setValue('credit.rank', defaultRankMaster?._id);
    }
    setRankDropdown(data);
  }, [selectedRecord]);

  const getFluTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('flutype-master');
    setFluTypeDropdown(data);
  }, []);

  const getStateDropdown = useCallback(async () => {
    const data = await dropdownFetch('state');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('address.state', defaultState?._id);
    }
    setStateName(data);
  }, [selectedRecord]);

  const getCityDropdown = useCallback(async () => {
    const data = await dropdownFetch('city');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('address.city', defaultState?._id);
    }
    setCityName(data);
  }, [selectedRecord]);

  useEffect(() => {
    getSponsorDropdown();
    getFluTypeDropdown();
    getRankDropdown();
    getopdTypeDropdown();
    getDepartmentDropdown();
    getDoctorUnitDropdown();
    getVerticalDropdown();
    getDoctorDropdown();
    getGuardianDropdown();
    getReferralDropdown();
    getDoctorFeeData();
    getStateDropdown();
    getCityDropdown();
    getDiscountmasterData();
  }, [
    getSponsorDropdown,
    getDoctorFeeData,
    getDoctorUnitDropdown,
    getFluTypeDropdown,
    getVerticalDropdown,
    getopdTypeDropdown,
    getDepartmentDropdown,
    getDoctorDropdown,
    getGuardianDropdown,
    getReferralDropdown,
    getRankDropdown,
    getStateDropdown,
    getCityDropdown,
    getDiscountmasterData
  ]);

  const ageCalculator = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let ageYear = today.getFullYear() - birthDate.getFullYear();
    let ageMonth = today.getMonth() - birthDate.getMonth();
    let ageDay = today.getDate() - birthDate.getDate();

    if (ageMonth < 0) {
      ageMonth += 12;
      ageYear -= 1;
    }
    if (ageDay < 0) {
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      ageDay += lastMonth.getDate();
      ageMonth -= 1;
    }

    return {
      years: ageYear,
      months: ageMonth,
      days: ageDay
    };
  };

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'dob', 'covid.first_date', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = newDate
        ? new Date().toISOString().split('T')[0]
        : selectedRecord?.date
          ? new Date(selectedRecord.date).toISOString().split('T')[0]
          : '';
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };
      const formattedRegtime = newDate
        ? new Date().toLocaleTimeString('en-IN', options).split('T')[0]
        : selectedRecord?.time
          ? selectedRecord?.time
          : '';
      setValue('date', formattedRegDate);
      setValue('time', formattedRegtime);
      setValue('dob', getCurrentDateTime('date', selectedRecord.dob)?.split('-').reverse().join('-'));
      setValue('age_year', ageCalculator(selectedRecord.dob).years);
      setValue('age_month', ageCalculator(selectedRecord.dob).months);
      setValue('age_day', ageCalculator(selectedRecord.dob).days);
      setValue('address.state', selectedRecord?.address?.state?._id || selectedRecord?.address.state);
      setValue('disc_type', selectedRecord?.disc_type?._id);
      setValue('charge', selectedRecord.charge === 'true');

      if (selectedRecord?.covid?.first_date) {
        setValue(
          'covid.first_date',
          getCurrentDateTime('date', selectedRecord.covid.first_date)?.split('-').reverse().join('-')
        );
      }
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const handleActiveTab = (newIndex) => {
    setActiveTab(newIndex);
  };

  const ageYearWatch = watch('age_year');
  const ageMonthWatch = watch('age_month');
  const ageDayWatch = watch('age_day');
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - ageYearWatch);
    currentDate.setMonth(currentDate.getMonth() - ageMonthWatch);
    currentDate.setDate(currentDate.getDate() - ageDayWatch);
    setValue('dob', getCurrentDateTime('date', currentDate).split('-').reverse().join('-'));
  }, [ageYearWatch, ageDayWatch, ageMonthWatch, setValue]);

  const formSubmit = async (formValue) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/patient-registeration-update' : '/patient-registeration-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValue,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation,
        charge: formValue.charge ? 'true' : 'false'
      }
    });
    if (response?.success) {
      handleAppointmentcount();
      //       try {
      //         const message = `Dear ${response?.data.first_name},
      // UHID No. ${response?.data.uhid}
      // OPD No. ${response?.data.op_no}
      // Welcome to ${user.nameOfOrg}. 
      // We are honored that you have chosen us for your healthcare needs.
      // We wish you a smooth and speedy recovery and are here to support you every step of the way.
      // Warm regards,
      // The ${user.nameOfOrg} Team`;
      //         const responsee = axios.post(`${BASE_URL}/proxy/send`, {
      //           number: `${response?.data?.address?.mobile || response.data?.patientRegisteration?.address?.mobile}`,
      //           type: 'text',
      //           message: encodeURIComponent(message)
      //         });
      //       } catch (error) {
      //         console.log(error);
      //       }
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Patient Registeration`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction('');
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Patient Registeration`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const sponsorWatch = watch('sponsor');
  const consultantWatch = watch('consultant');
  const opdTypeWatch = watch('opd_type');
  const chargeWatch = watch('charge');
  const otherCharge = watch('other_charge');
  const discountPer = watch('disc_type');

  useEffect(() => {
    const data = discountMasterDropdown.find((data) => data._id === discountPer);
    setDiscountPercentage(data?.discount_percentage);
  }, [discountPer]);

  console.log(selectedRecord, "SELECTED RECORD")
  useEffect(() => {
    // If selectedRecord exists, prioritize setting values from it
    if (selectedRecord) {
      setValue('reg', selectedRecord.reg || 0);
      setValue('cons', selectedRecord.cons || 0);
      setValue('disc', selectedRecord.disc || 0);
      setValue('total', selectedRecord.total || 0);
      setValue('recd', selectedRecord.recd || 0);
      setValue('bal', selectedRecord.bal || 0);
      setValue('rec_amt_1', selectedRecord.rec_amt_1 || 0);
      setValue('rec_amt_2', selectedRecord.rec_amt_2 || 0);
      setValue('other_charge', selectedRecord.other_charge || 0);
      return; // Skip the rest of the logic
    }

    // Continue with default flow if no selectedRecord
    if (!sponsorWatch || !consultantWatch || !opdTypeDropdown) return;

    const opdFeeType = doctorFeeData.filter(
      (data) => data.doctor === consultantWatch && data.sponsor === sponsorWatch
    )[0]?.opd_type_fee;

    if (!opdFeeType) return;

    const selectedOpdType = opdFeeType.find(({ opd_type }) => opd_type === opdTypeWatch);

    if (!selectedOpdType) {
      setValue('reg', 0);
      setValue('cons', 0);
      setValue('disc', 0);
      setValue('total', 0);
    } else {
      if (discountPercentage) {
        let amountDis = parseFloat(
          selectedOpdType?.amount - (selectedOpdType?.amount * discountPercentage) / 100
        );
        setValue('reg', amountDis);
        setValue('cons', amountDis);
        setValue('disc', selectedOpdType?.discount);
        setValue('total', otherCharge + selectedOpdType?.amount - selectedOpdType?.discount);
      } else {
        setValue('reg', selectedOpdType?.amount);
        setValue('cons', selectedOpdType?.amount);
        setValue('disc', selectedOpdType?.discount || 0);
        setValue('total', otherCharge + selectedOpdType?.amount - selectedOpdType?.discount);
      }
    }

    if (chargeWatch) {
      setValue('other_charge', selectedOpdType?.other_charge ? selectedOpdType?.other_charge : 0);
    } else {
      setValue('other_charge', '');
    }
  }, [
    sponsorWatch,
    consultantWatch,
    opdTypeWatch,
    doctorFeeData,
    discountPercentage,
    chargeWatch,
    otherCharge,
    consultantWatch,
    selectedRecord
  ]);

  const totalWatch = watch('total');
  const receiptModeWatch = watch('receipt_mode');
  useEffect(() => {
    const regValue = watch('reg');
    const discValue = watch('disc');
    const totalAmount = otherCharge + regValue - discValue;

    // Update total and recd when reg changes manually
    setValue('total', totalAmount);

    const receiptModeWatch = watch('receipt_mode');
    let recd = totalAmount;
    if (receiptModeWatch === 'Credit') {
      recd = 0;
    }
    setValue('recd', recd);
    setValue('cons', regValue);
    setValue('bal', totalAmount - recd);

    // Cash/Bank split: auto-derived for single-method modes; left to the user
    // for 'Both' (see the dedicated effect below that seeds a default only
    // when receipt_mode itself switches to 'Both').
    if (receiptModeWatch !== 'Both') {
      const modeType = RECEIPT_MODE.find((mode) => mode._id === receiptModeWatch)?.type;
      if (modeType === 'cash') {
        setValue('rec_amt_1', recd);
        setValue('rec_amt_2', 0);
      } else if (modeType === 'bank') {
        setValue('rec_amt_1', 0);
        setValue('rec_amt_2', recd);
      } else {
        setValue('rec_amt_1', 0);
        setValue('rec_amt_2', 0);
      }
    }
  }, [watch('reg'), watch('disc'), watch('receipt_mode'), setValue, otherCharge]);

  // Seed a starting Cash/Bank split (full cash by default) only when receipt_mode
  // itself changes to 'Both' — not on every reg/disc recompute, so the user's
  // manual split isn't stomped while they're still editing other amounts.
  useEffect(() => {
    if (receiptModeWatch === 'Both') {
      setValue('rec_amt_1', watch('recd') || 0);
      setValue('rec_amt_2', 0);
    }
  }, [receiptModeWatch]);

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/patient-registeration-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Patient Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Patient Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/patient-registeration-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Patient Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Patient Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setPatientDataObj({ loading: true });
    try {
      const response = await request('/patient-registeration-list', { method: 'GET' });

      if (response.success) {
        const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPatientDataObj({ loading: false, data: filteredData });
        setOriginalData(sortedData);
      } else {
        toast('Error in fetchingggggggg data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const handleAppointmentWindow = async () => {
    setOpenAppointmentDialog(true);
    setAppointmentDataObj({ loading: true, data: [] });
    try {
      const query = { patient_registeration: false };
      const response = await request('/appointment-list', { method: 'GET', query: query });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) =>
            item.authorize === true &&
            (item.status === 'active' || item.status === 'inactive' || item.status === 'default')
        );
        setAppointmentDataObj({ loading: false, data: filteredData });
        setOriginalData(filteredData);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setAppointmentDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setAppointmentDataObj({ loading: false, data: [] });
    }
  };

  const handleAppointmentcount = async () => {
    setAppointmentDataObj({ loading: true, data: [] });
    try {
      const query = { patient_registeration: false };
      const response = await request('/appointment-list', { method: 'GET', query: query });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        // Filter and count confirmed appointments
        const filteredDataConfirm = sortedData.filter(
          (item) =>
            item.authorize === true &&
            (item.status === 'active' || item.status === 'inactive' || item.status === 'default')
        );

        // Filter and count pending appointments
        const filteredDataPending = sortedData.filter(
          (item) =>
            item.authorize === false &&
            (item.status === 'active' || item.status === 'inactive' || item.status === 'default')
        );

        // Set state for the counts
        setNotificationCountConfirm(filteredDataConfirm.length);
        setNotificationCountPending(filteredDataPending.length);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setAppointmentDataObj({ loading: true, data: [] });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setAppointmentDataObj({ loading: true, data: [] });
    }
  };

  useEffect(() => {
    handleAppointmentcount();
  }, []);

  useEffect(() => {
    if (patientDataObj.data && patientDataObj.data.length > 0) {
      setOriginalData(patientDataObj.data);
      setIsFiltered(false);
    }
  }, [patientDataObj.data]);

  const handleUhidSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput;
        query.endDate = endDateInput;
      }
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/patient-registeration-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPatientDataObj({ loading: false, data: filteredData });
        setOriginalData(sortedData);
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setOriginalData({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOriginalData({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(() => {
    handleUhidSearch(input);
  }, [input]);

  useEffect(() => {
    if (appointmentDataObj.data && appointmentDataObj.data.length > 0) {
      setAppointmentOriginalData(appointmentDataObj.data);
      setIsFiltered(false);
    }
  }, [appointmentDataObj.data]);

  useEffect(() => {
    handleAppointmentSearch(appointmentInput);
  }, [appointmentInput]);

  const handleAppointmentSearch = () => {
    const lowercasedInput = appointmentInput.toLowerCase();
    const filtered = appointmentDataObj.data.filter(
      (item) =>
        item.app_no.toString().toLowerCase().includes(lowercasedInput) ||
        item.patient_name.toString().toLowerCase().includes(lowercasedInput)
    );
    setAppointmentOriginalData(filtered);
  };

  const handleAppointmentChange = (e) => {
    const newInput = e.target.value;
    setAppointmentInput(newInput);
  };

  useEffect(() => {
    const nameSuffix = watch('name_suffix');
    if (nameSuffix) {
      if (nameSuffix === 'Mr.') {
        let maleGuardian = true;
        const NameSuffix = guardianDropdown.find((item) => item.name === 'S/o');
        if (maleGuardian) {
          setValue('guardian_type', NameSuffix?._id);
          setValue('gender', 'Male');
        }
      } if (nameSuffix === 'Baby') {
        let maleGuardian = true;
        const NameSuffix = guardianDropdown.find((item) => item.name === 'B/o');
        if (maleGuardian) {
          setValue('guardian_type', NameSuffix?._id);
          setValue('gender', 'Male');
        }
      } else if (nameSuffix === 'Miss' || nameSuffix === 'Mrs.') {
        let femaleGuardian = true;
        const NameSuffix =
          nameSuffix === 'Miss'
            ? guardianDropdown.find((item) => item.name === 'D/o')
            : guardianDropdown.find((item) => item.name === 'W/o');
        if (femaleGuardian) {
          setValue('guardian_type', NameSuffix?._id);
          setValue('gender', 'Female');
        }
      }
    }
  }, [watch('name_suffix'), guardianDropdown, setValue]);

  const opdTypeWatching = watch('opd_type');
  useEffect(() => {
    const selectedOption = opdTypeDropdown.find((data) => data._id === opdTypeWatching);
    if (selectedOption?.type === 'Emergency') {
      setSelectedOpdType(true);
    } else {
      setSelectedOpdType(false);
    }
  }, [opdTypeWatching]);

  const handleStartChangeDate = (e) => {
    setStartDateInput(e.target.value);
  };

  const handleEndChangeDate = (e) => {
    setEndDateInput(e.target.value);
  };

  const handleSearchByDate = async () => {
    setPatientDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput;
        query.endDate = endDateInput;
      }
      const response = await request('/patient-registeration-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPatientDataObj({ loading: false, data: filteredData });
        setOriginalData(sortedData);
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setOriginalData({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOriginalData({ loading: false, data: [] });
    }
  };

  const receiptMode = watch('receipt_mode');
  useEffect(() => {
    if (receiptMode === 'CASH') {
      setValue('payment_mode', 'CASH');
    } else if (receiptMode === 'Credit') {
      setValue('payment_mode', 'Credit');
    } else{
      setValue('payment_mode', 'Bank');
    }
  }, [receiptMode]);


  const mobile = watch('address.mobile')
  const isRqtyInvalid = 10 >= mobile;

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Patient Registeration
              </Typography>
              <Badge
                badgeContent={notificationCountPending} // The notification count
                color="primary" // Red badge color
                overlap="circular" // Make the badge circular
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }} // Position badge at top-left corner
                sx={{
                  fontSize: '4rem', // Size of the icon itself
                  position: 'relative',
                  '& .MuiBadge-dot': {
                    // Target the badge content (the number inside the badge)
                    fontSize: '2rem', // Set the font size of the number (not 50rem, which is too large)
                    fontWeight: 'bold', // Optional: Make the number bold
                    color: 'white' // Optional: Change the text color of the number
                  }
                }}
              >
                <NotificationAddIcon sx={{ fontSize: '4rem', color: 'red' }} />
              </Badge>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id="billing"
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    const baseUrl = window.location.origin;
                    const relativePath = '/hospital/outpatient-management/opd-billing';
                    const uhid = selectedRecord?.uhid;
                    const fullUrl = selectedRecord
                      ? `${baseUrl}${relativePath}?uhid=${uhid}`
                      : `${baseUrl}${relativePath}`;
                    window.open(fullUrl, '_blank');
                  }}
                >
                  Opd Billing
                </CustomButtonn>


                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => {
                    navigate(
                      `${pathname}/${selectedRecord?._id}/documents`
                    );
                  }}

                  disabled={!selectedRecord || currentAction}
                >
                  Documents
                </CustomButtonn>

                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => {
                    window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank');
                  }}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => {
                    window.open(`/print${pathname}/emergency-print?refId=${selectedRecord._id}`, '_blank');
                  }}
                  disabled={!selectedOpdType}
                >
                  Emergency Print
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => {
                    window.open(`/print${pathname}/invoice-print?refId=${selectedRecord._id}`, '_blank');
                  }}
                  disabled={!selectedRecord || currentAction}
                >
                  invoice Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                    setSelectedRecord(null);
                    window.location.reload();
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Appointment No.</Typography>
                  <TextField disabled sx={{ flex: 0.2 }} name="app_no" placeholder="App No." />
                  <Button
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{
                      flex: 0.1,
                      minWidth: 0,
                      p: 0.25,
                      height: '100%',
                      position: 'relative'
                    }}
                    variant="contained"
                    onClick={handleAppointmentWindow}
                  >
                    <SearchIcon sx={{ fontSize: '2rem' }} />
                    <Badge
                      badgeContent={notificationCountConfirm} // The notification count
                      color="error" // Red badge color
                      overlap="circular" // Make the badge circular
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position badge at top-right corner
                      sx={{
                        fontSize: '4rem', // Size of the number inside the badge
                        position: 'absolute', // Position the badge inside the button
                        top: '0px', // Move the badge to the top
                        right: '0px', // Move the badge to the right
                        '& .MuiBadge-dot': {
                          fontSize: '1.5rem', // Set the font size of the number inside the badge
                          fontWeight: 'bold', // Optional: Make the number bold
                          color: 'white' // Optional: Change the text color of the number
                        }
                      }}
                    />
                  </Button>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>OPD No.</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="op_no" />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID/Visit No</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="uhid" placeholder="UHID" />
                  <TextField sx={{ flex: 0.3 }} name="visit_no" placeholder="1" disabled />
                  <Button
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                    variant="contained"
                    onClick={() => {
                      setnewDate(true);
                      handleQueryWindow();
                    }}
                  >
                    <SearchIcon />
                  </Button>
                  {/* <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Consult</Typography>
                  <Checkbox
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.1, p: 0 }}
                    name="consult"
                  /> */}
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.8, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time/Token</Typography>
                  <TextField
                    sx={{ flex: 0.6 }}
                    name="date"
                    type="date"
                    placeholder="Date"
                    disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.5 }}
                    name="time"
                    type="time"
                    placeholder="Time"
                    disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                  />
                  <TextField sx={{ flex: 0.4 }} name="token_no" placeholder="" disabled />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>First Name</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.2 }}
                    name="name_suffix"
                    menus={TITLES}
                  />
                  <TextField
                    inputRef={fieldOneRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldTwoRef)}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{
                      flex: 0.6,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="first_name"
                    placeholder="First Name"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Last Name</Typography>
                  <TextField
                    inputRef={fieldTwoRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldThreeRef)}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{
                      flex: 0.8
                    }}
                    name="last_name"
                    placeholder="Last Name"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Guardian</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.2 }}
                    name="guardian_type"
                    menus={guardianDropdown}
                  />
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{
                      flex: 0.6,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="guardian_name"
                    placeholder="Guardian Name"
                    inputRef={fieldThreeRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFourRef)}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mother's Name</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="mother_name"
                    placeholder="Mother's name"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Gen/DOB</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{
                      flex: 0.4,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="gender"
                    menus={GENDER_DROPDOWN}
                    inputRef={fieldFourRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFiveRef)}
                  />
                  <TextField disabled sx={{ flex: 0.4 }} type="date" name="dob" />
                </Stack>

                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Age</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{
                      flex: 0.8 / 3,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    type="number"
                    name="age_year"
                    inputRef={fieldFiveRef}
                    placeholder="Year"
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        e.target.value = '';
                      }
                      handleKeyPress(e, fieldSixRef);
                    }}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="age_month"
                    placeholder="Month"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="age_day"
                    type="number"
                    placeholder="Day"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Religion/BG</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}
                    name="religion"
                    menus={RELIGIONS}
                  />
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.4 }}
                    name="blood_group"
                    menus={BLOOD_GROUPS}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Vertical</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="vertical"
                    menus={verticalDropdown.map((data) => ({ ...data, name: data.verticalname }))}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} alignItems="center" direction="row" spacing={0.5}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ref. By</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="ref_by"
                    menus={referralDropdown.map((data) => ({ ...data, name: data.referral_name }))}
                  />
                  <IconButton
                    size="small"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    onClick={() => setOpenReferralDialog(true)}
                    sx={{ p: 0.3 }}
                  >
                    <AddCircleIcon fontSize="small" color="primary" />
                  </IconButton>
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.4} sx={{ flex: 1 / 3 }} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="sponsor"
                    menus={sponsorDropdown}
                  />
                </Stack>
                <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Consultant</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{
                      flex: 0.8,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="consultant"
                    placeholder="Consultant"
                    menus={doctorDropdown}
                    onChange={({ target: { row } }) => {
                      setValue('department', row.qualification_details.department);
                    }}
                    inputRef={fieldSixRef}
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        e.target.value = '';
                      }
                      handleKeyPress(e, fieldSevenRef);
                    }}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                  <SelectTag
                    disabled
                    formControlSX={{ flex: 0.8 }}
                    name="department"
                    menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Consult. Unit</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="consult_unit"
                    menus={doctorUnitDropdown.map((data) => ({ ...data, name: data.unit }))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Reg. Loc.</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="reg_loc"
                    placeholder="Location"
                    menus={REG_LOCATION}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>OPD Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="opd_type"
                    menus={opdTypeDropdown.map((data) => ({ ...data, name: data.type }))}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Nationality</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="nationality"
                    menus={NATIONALITY}
                  />
                </Stack>
                <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Disc. Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.6 }}
                    name="disc_type"
                    menus={discountMasterDropdown.map((data) => ({ ...data, name: data?.discount_name }))}
                  />
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem', flex: 1 / 3 }}>Charges</Typography>
                  <Checkbox
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2, p: 0 }}
                    name="charge"
                  />
                </Stack>
              </Stack>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}></Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={() => handleActiveTab(0)}
                  sx={{
                    my: 0,
                    marginTop: '0.5%',
                    marginBottom: '0.1%',
                    mx: 1,
                    borderRadius: '4px',
                    fontWeight: 700
                  }}
                >
                  Address Details
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleActiveTab(2)}
                  sx={{
                    my: 0,
                    marginTop: '0.5%',
                    marginBottom: '0.1%',
                    mx: 1,
                    borderRadius: '4px',
                    fontWeight: 700
                  }}
                >
                  Credit Details
                </Button>
              </Grid>
              {activeTab === 0 && (
                <>
                  {/* <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}> */}
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{
                          flex: 0.8,
                          border: currentAction ? '0.5px solid red' : ''
                        }}
                        name="address.address"
                        placeholder="Address"
                        inputRef={fieldSevenRef}
                        onKeyDown={(e) => handleKeyPress(e, fieldEightRef)}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Town/Area</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.area"
                        placeholder="Town/Area"
                      />
                    </Stack>

                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>District</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.district"
                        placeholder="District"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        menus={[{ _id: 'IN', name: 'India' }]}
                        disabled={true}
                        name="address.country"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>State</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        // menus={getStatesByCountry(watch('address.country'))}
                        menus={[
                          // ...(getStatesByCountry(watch('address.country')) || []),
                          ...stateName.map((data) => ({ ...data, name: data.state }))
                        ]}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="address.state"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="address.city"
                        // menus={getCityByState(watch('address.country'), watch('address.state'))}
                        menus={[
                          // ...(getCityByState(watch('address.country'), watch('address.state')) || []),
                          ...cityName.map((data) => ({ ...data, name: data.city }))
                        ]}
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Pincode</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.pincode"
                        placeholder="Pincode"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Email</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.email"
                        placeholder="Email"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{
                          flex: 0.32,
                          border: currentAction ? '0.5px solid red' : ''
                        }}
                        name="address.mobile"
                        type="number"
                        placeholder="Mobile"
                        inputRef={fieldEightRef}
                        onKeyDown={(e) => handleKeyPress(e, fieldOneRef)}
                        error={isRqtyInvalid || (mobile && mobile.length !== 10)}
                        helperText={
                          isRqtyInvalid
                            ? 'Mobile number must be exactly 10 digits'
                            : mobile && mobile.length !== 10
                              ? 'Mobile number must be exactly 10 digits'
                              : ''
                        }
                        inputProps={{ maxLength: 10 }}
                        onInput={(e) => {
                          if (e.target.value.length > 10) {
                            e.target.value = e.target.value.slice(0, 10);
                          }
                        }}

                      />
                      <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Alt. Mobile</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.2 }}
                        name="address.alt_mobile"
                        placeholder="Alt. Mobile"
                        type="number"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>ID Type/No</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.3 }}
                        name="address.id_type"
                        placeholder="ID Type"
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.5 }}
                        name="address.id_no"
                        placeholder="ID No"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Aadhar No.</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.aadhar"
                        placeholder="Aadhar No."
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Employee ID</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="address.employee_id"
                        placeholder="Employee ID"
                      />
                    </Stack>
                  </Stack>
                </>
              )}
              {activeTab === 1 && (
                <>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Country</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        menus={[{ _id: 'IN', name: 'India' }]}
                        disabled={true}
                        name="correspondance.country"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>State</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        menus={getStatesByCountry(watch('correspondance.country'))}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="correspondance.state"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>City/Dist.</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        menus={getCityByState(watch('correspondance.country'), watch('correspondance.state'))}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="correspondance.city"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Town/Area</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="correspondance.area"
                        placeholder="Area"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Pincode</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="correspondance.pincode"
                        placeholder="Pincode"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Address</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="correspondance.address"
                        placeholder="Address"
                      />
                    </Stack>
                  </Stack>

                  <Grid item xs={12}>
                    <Typography fontWeight="bold">Emergency Contact</Typography>
                    <Divider />
                  </Grid>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Rel/Name</Typography>
                      <TextField
                        sx={{ flex: 0.4 }}
                        name="correspondance.emergency_contact.relation"
                        placeholder="Relation"
                        disabled={!['new', 'edit'].includes(currentAction)}
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="correspondance.emergency_contact.name"
                        placeholder="Name"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Email/Mob</Typography>
                      <TextField
                        type="email"
                        sx={{ flex: 0.4 }}
                        name="correspondance.emergency_contact.email"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        placeholder="Email"
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="correspondance.emergency_contact.mobile"
                        placeholder="Mobile"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3 }}>Address</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="correspondance.emergency_contact.address"
                        placeholder="Address"
                      />
                    </Stack>
                  </Stack>
                </>
              )}
              {activeTab === 2 && (
                <>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Card/Echs No.</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.card_no"
                        placeholder="Credit Card No."
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Card Type</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="credit.card_type"
                        menus={CARD_TYPE}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Reg. Number</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.reg_number"
                        placeholder="Reg. Number"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Date of Reg.</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        type="date"
                        name="credit.date_reg"
                        placeholder="Date of Reg."
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Emp ID</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.emp_id"
                        placeholder="Emp ID"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Rel with ESM</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.rel_esm"
                        placeholder="Rel with ESM"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>ESM UHID</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.esm_uhid"
                        placeholder="ESM UHID"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Rank</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="credit.rank"
                        menus={rankDropdown.map((data) => ({ ...data, name: data.rankname }))}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Service No</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="credit.service_no"
                        placeholder="Service No"
                      />
                    </Stack>
                  </Stack>
                </>
              )}
              {activeTab === 3 && (
                <>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>Is fever, Sore Throat, Cough, Breathles</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="covid.symptom"
                        menus={YES_NO}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.5 }}>Flu Type</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.5 }}
                        name="covid.flu_type"
                        menus={fluTypeDropdown.map((data) => ({ ...data, name: data.flutypename }))}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>First Date</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.3 }}
                        name="covid.first_date"
                        type="date"
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>International Travel within 28 days?</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="covid.travel"
                        menus={YES_NO}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.5 }}>Covid Report-1</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.5 }}
                        name="covid.report"
                        menus={YES_NO}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>Screen for SARI? (Yes/No)</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="covid.screen_for_sari"
                        menus={YES_NO}
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.5 }}>Patient Brought From</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.5 }}
                        name="covid.brought_from"
                        placeholder="From"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>All Suspected Health Care Workers</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="covid.suspected_health_care"
                        menus={YES_NO}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.5 }}>Antibody Testing for Covid-19 (Yes/No)</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.5 }}
                        name="covid.antibody_testing"
                        menus={YES_NO}
                      />
                    </Stack>
                  </Stack>
                  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.7 }}>History of Covid Contact</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="covid.history"
                        menus={YES_NO}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                      <Typography sx={{ flex: 0.5 }}>Patient Brought By</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.5 }}
                        name="covid.brought_by"
                        placeholder="Brought By"
                      />
                    </Stack>
                  </Stack>
                </>
              )}
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Reg/Cons/Disc/Other</Typography>
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="reg"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="cons"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="disc"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="other_charge"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total/Recd/Bal</Typography>
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="total"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="recd"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.8 / 3 }}
                    name="bal"
                    type="number"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="remarks"
                    placeholder="Remarks"
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Receipt Mode</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="receipt_mode"
                    allowClear={true}
                    onChange={() => {
                      setValue('payment_mode', '');
                    }}
                    menus={RECEIPT_MODE}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bank/Cash</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction) || receiptMode === 'Both'}
                    formControlSX={{ flex: 0.8 }}
                    name="payment_mode"
                    allowClear={true}
                    menus={BANK_CASH.filter(
                      ({ type }) => type === RECEIPT_MODE.filter((mode) => mode._id === watch('receipt_mode'))[0]?.type
                    )}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Chq/Card No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="chq_card_no"
                    placeholder="Chq/Card No"
                  />
                </Stack>
              </Stack>
              {receiptMode === 'Both' && (
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Cash Amt</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="rec_amt_1"
                      type="number"
                      inputProps={{ min: '0' }}
                      placeholder="Cash Amount"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bank Amt</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="rec_amt_2"
                      type="number"
                      inputProps={{ min: '0' }}
                      placeholder="Bank Amount"
                    />
                  </Stack>
                </Stack>
              )}
            </Box>
            {/* </Grid> */}
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => {
          setOpenQueryDialog(false);
          setStartDateInput('');
          setEndDateInput('');
        }}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Registeration Query Window
          </Typography>
          <IconButton
            onClick={() => {
              setOpenQueryDialog(false);
              setStartDateInput('');
              setEndDateInput('');
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            placeholder="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{
            mt: 1,
            mb: 1,
            width: '60%',
            gap: 2,
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            From Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            variant="outlined"
            name="from_date"
            type="date"
            onChange={handleStartChangeDate}
            value={startDateInput}
          />

          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            To Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            name="to_date"
            variant="outlined"
            type="date"
            onChange={handleEndChangeDate}
            value={endDateInput}
          />
          <Button variant="contained" disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>
            Search
          </Button>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={originalData || []}
          loading={patientDataObj.loading}
          onRowClick={(row) => {
            const {
              opd_type,
              department,
              ref_by,
              vertical,
              consultant,
              guardian_type,
              sponsor,
              covid,
              consult_unit,
              credit,
              ...otherDetails
            } = row;
            setSelectedRecord({
              ...otherDetails,
              guardian_type: guardian_type?._id,
              consult_unit: consult_unit?._id,
              opd_type: opd_type?._id,
              department: department?._id,
              ref_by: ref_by?._id,
              vertical: vertical?._id,
              consultant: consultant?._id,
              sponsor: sponsor?._id,
              covid: { ...covid, flu_type: covid?.flu_type?._id },
              credit: { ...credit, rank: credit?.rank?._id }
            });
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={openAppointmentDialog}
        onClose={() => setOpenAppointmentDialog(false)}
        PaperProps={{ sx: { width: '60%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Appointments
          </Typography>
          <IconButton onClick={() => setOpenAppointmentDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0.5 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            placeholder="Search Patient"
            variant="outlined"
            value={appointmentInput}
            onChange={handleAppointmentChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={APPOINTMENT_TABLE_COLUMNS}
          data={appointmentOriginalData || []}
          loading={patientDataObj.loading}
          onRowClick={(row) => {
            console.log(row, "ROW")
            const {
              address,
              town,
              age,
              patient_name,
              consultant,
              date,
              time,
              state,
              category,
              city,
              doctor,
              mobile,
              ...otherDetails
            } = row;
            setSelectedRecord({
              ...otherDetails,
              age_year: age,
              address: {
                address: address,
                mobile: mobile,
                state: state,
                city: city
              },
              first_name: patient_name,
              consultant: doctor?._id,
              sponsor: category?._id,
              date: new Date().toISOString().split('T')[0],
              time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
            });
            setOpenAppointmentDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={openReferralDialog}
        onClose={() => {
          setOpenReferralDialog(false);
          setNewReferralType('');
          setNewReferralName('');
        }}
        PaperProps={{ sx: { width: '35%', p: 2 } }}
        maxWidth="sm"
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Add Referral
          </Typography>
          <IconButton
            onClick={() => {
              setOpenReferralDialog(false);
              setNewReferralType('');
              setNewReferralName('');
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <MuiTextField
            select
            label="Referral Type"
            value={newReferralType}
            onChange={(e) => setNewReferralType(e.target.value)}
            fullWidth
          >
            {REFERRAL_TYPE.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.name}
              </MenuItem>
            ))}
          </MuiTextField>
          <MuiTextField
            label="Referral Name"
            value={newReferralName}
            onChange={(e) => setNewReferralName(e.target.value)}
            fullWidth
          />
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={() => {
                setOpenReferralDialog(false);
                setNewReferralType('');
                setNewReferralName('');
              }}
            >
              Cancel
            </Button>
            <Button variant="contained" disabled={referralSaving} onClick={handleAddReferral}>
              Save
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
};
